var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 628.42 458.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#e3eaff;}.cls-4{fill:#fff;}.cls-5{fill:#f37a50;}.cls-6{fill:#de623c;}.cls-7{fill:#201d40;}.cls-8{fill:#2c2858;}.cls-9{fill:#e62552;}.cls-10{fill:#c4204a;}.cls-11{fill:#95a6db;}.cls-12{fill:#768fdb;}.cls-13{fill:#8a284c;}.cls-14{fill:#494c7f;}.cls-15{fill:#0e6a41;}.cls-16{fill:#ff4f78;}.cls-17{fill:#3f964f;}.cls-18{fill:#ffe91d;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0.02)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 628.42,
    height: 458.48
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_775",
    "data-name": "Group 775"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2192",
    "data-name": "Path 2192",
    className: "cls-3",
    d: "M86.14,455.88C42,407.81-18.34,358.18,5.32,283.2c15.56-49.31,53.72-63,85.43-93.46,15.65-15,5.81-36.85,5.52-58.53-.67-55.52,61.29-98.6,118.25-97.7,61.7,1,88.41,63,140.17,66.33,20.32.31,38.52-11.61,56.5-21.09C464.47,50.68,549,68.58,553.29,136.47c1.1,36.67-40.63,95.65,1.18,114.94,33.32,15.37,67,21,73,76,7.86,71.94-33.69,111.43-87.84,130Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    className: "cls-4",
    d: "M115,182.27h61.43A13.77,13.77,0,0,1,190.21,196h0v28.64a13.78,13.78,0,0,1-13.77,13.77H176L180.91,255a.77.77,0,0,1-.52,1,.8.8,0,0,1-.7-.13l-22.76-17.36H115a13.78,13.78,0,0,1-13.77-13.77h0V196A13.77,13.77,0,0,1,115,182.27",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    className: "cls-3",
    d: "M176.41,206.31h-59a6.82,6.82,0,0,1,0-13.63h59a6.82,6.82,0,1,1,0,13.63",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2195",
    "data-name": "Path 2195",
    className: "cls-3",
    d: "M176.41,227.12h-59a6.82,6.82,0,0,1,0-13.63h59a6.82,6.82,0,0,1,0,13.63h0",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2196",
    "data-name": "Path 2196",
    className: "cls-4",
    d: "M491,105H424a15,15,0,0,0-15,15h0v31.23a15,15,0,0,0,15,15h.5l-5.38,18a.85.85,0,0,0,.57,1.06.83.83,0,0,0,.76-.14l24.83-18.93H491a15,15,0,0,0,15-15V120a15,15,0,0,0-15-15",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2197",
    "data-name": "Path 2197",
    className: "cls-3",
    d: "M490.38,131.36H422.93a6.07,6.07,0,0,1-6.06-6.05h0v-1.51a6.07,6.07,0,0,1,6.06-6.06h67.46a6.05,6.05,0,0,1,6.05,6.06v1.51a6.05,6.05,0,0,1-6.05,6.06h0",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2198",
    "data-name": "Path 2198",
    className: "cls-3",
    d: "M457.46,152H425.87a6.81,6.81,0,0,1-6.81-6.81h0a6.81,6.81,0,0,1,6.81-6.81h31.59a6.81,6.81,0,0,1,6.81,6.81h0a6.81,6.81,0,0,1-6.81,6.82h0",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    className: "cls-4",
    d: "M43.88,336.36A14.72,14.72,0,0,1,53,333.48c7.68,0,11.74,4.18,11.74,10,0,3.38-1.63,6.82-5,10.27-4.24,4.46-7.28,6.66-9.2,6.66a3.18,3.18,0,0,1-3.22-3.15v-.07c0-1.58,1.47-3.16,4-5.47a2.15,2.15,0,0,1,.45-.4c2.88-2.65,3.78-4.12,3.78-5.92,0-2.26-1.52-3.5-3.72-3.5a12.39,12.39,0,0,0-3.62.67,11.35,11.35,0,0,1-3,.68,3.52,3.52,0,0,1-3.39-3.61,4.28,4.28,0,0,1,2-3.33M51.61,374a5.61,5.61,0,0,1-5.75-5.45,1.61,1.61,0,0,1,0-.31,5.51,5.51,0,0,1,5.75-5.3,5.41,5.41,0,0,1,5.31,5.3A5.48,5.48,0,0,1,51.61,374",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2200",
    "data-name": "Path 2200",
    className: "cls-4",
    d: "M504.91,209.73a9.67,9.67,0,0,1,6-1.89c5.05,0,7.72,2.74,7.72,6.6,0,2.23-1.08,4.49-3.27,6.76-2.78,2.93-4.78,4.38-6.05,4.38a2.1,2.1,0,0,1-2.11-2.07v0c0-1,1-2.08,2.63-3.6a1.48,1.48,0,0,1,.3-.26c1.89-1.74,2.49-2.71,2.49-3.9a2.21,2.21,0,0,0-2.45-2.3,8.09,8.09,0,0,0-2.38.45,7.24,7.24,0,0,1-2,.44,2.31,2.31,0,0,1-2.23-2.37,2.8,2.8,0,0,1,1.34-2.19M510,234.48a3.68,3.68,0,0,1-3.78-3.58.67.67,0,0,1,0-.2,3.62,3.62,0,0,1,3.76-3.49h0a3.64,3.64,0,0,1,0,7.27",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2201",
    "data-name": "Path 2201",
    className: "cls-4",
    d: "M615.91,346.88H545.46a2.26,2.26,0,0,1-2.26-2.25V284a2.26,2.26,0,0,1,4.51,0v58.39h68.2a2.26,2.26,0,1,1,.08,4.52h-.08",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    "data-name": "Path 2202",
    className: "cls-4",
    d: "M550.79,332.06a2.26,2.26,0,0,1-1.62-3.83l22.77-23.55a2.26,2.26,0,0,1,2.85-.33l10.77,7,11.36-13.2a2.25,2.25,0,1,1,3.41,2.94l-12.64,14.69a2.23,2.23,0,0,1-2.93.42l-10.87-7-21.48,22.22a2.2,2.2,0,0,1-1.62.68",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    className: "cls-4",
    d: "M600.38,307.81l-3.21-6.51-6.92-2.2,15.4-7.65Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2204",
    "data-name": "Path 2204",
    className: "cls-4",
    d: "M142.55,126.94a13.65,13.65,0,1,1,13.65-13.65,13.65,13.65,0,0,1-13.65,13.65m0-23.54a9.89,9.89,0,1,0,9.89,9.89,9.89,9.89,0,0,0-9.89-9.89",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    "data-name": "Path 2205",
    className: "cls-3",
    d: "M559,235.57a10,10,0,1,1,10-10h0a10,10,0,0,1-10,10m0-17.24a7.25,7.25,0,1,0,7.25,7.24h0a7.27,7.27,0,0,0-7.25-7.24",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    className: "cls-4",
    d: "M34.11,290.38a9,9,0,1,1,9-9h0a9,9,0,0,1-9,9m0-15.48a6.5,6.5,0,1,0,6.51,6.5h0a6.51,6.51,0,0,0-6.51-6.5",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    className: "cls-4",
    d: "M515.3,87.13a4.89,4.89,0,1,1-4.88-4.89,4.88,4.88,0,0,1,4.88,4.89h0",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    "data-name": "Path 2208",
    className: "cls-3",
    d: "M87.24,177.55a9.6,9.6,0,1,1-9.6-9.61,9.6,9.6,0,0,1,9.6,9.61h0",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    "data-name": "Path 2209",
    className: "cls-3",
    d: "M544.48,68.19A7.22,7.22,0,1,1,537.27,61a7.21,7.21,0,0,1,7.21,7.22h0",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    className: "cls-3",
    d: "M579.81,241.53a6.16,6.16,0,1,1-6.16-6.16h0a6.16,6.16,0,0,1,6.16,6.16",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    className: "cls-4",
    d: "M526.47,105.52a7.68,7.68,0,1,1-7.68-7.68,7.68,7.68,0,0,1,7.68,7.68h0",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    className: "cls-4",
    d: "M173.15,91.57a7.8,7.8,0,1,1-7.8-7.79h0a7.79,7.79,0,0,1,7.79,7.79",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    className: "cls-5",
    d: "M233,221.48h0l7.08,0,1.6,16.72-8.26,4.36-8.82-4.31L226,221.51Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    "data-name": "Path 2214",
    className: "cls-5",
    d: "M213.54,214.1C217.9,225,228.36,231,236.91,227.62s12-15,7.6-25.91-14.83-16.94-23.38-13.52-11.95,15-7.59,25.91",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    d: "M240.79,205.28a1.6,1.6,0,1,0,.4-2.23,1.6,1.6,0,0,0-.4,2.23h0",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M228.79,210.18a1.74,1.74,0,1,0,.43-2.42,1.73,1.73,0,0,0-.43,2.42",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    className: "cls-6",
    d: "M238.36,207.84c2.16,1.7,4.87,3.76,4.87,3.76a4.21,4.21,0,0,1-3,3.75c1.1-1,2.07-2.33.92-3.87s-2.77-3.64-2.77-3.64",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    className: "cls-7",
    d: "M225.63,209.13a.8.8,0,0,1-.8-.8,1.1,1.1,0,0,1,0-.18c.28-1.17,1.46-3.39,3.9-3.41a.8.8,0,0,1,0,1.6c-1.8,0-2.33,2.16-2.34,2.18a.8.8,0,0,1-.78.61",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    className: "cls-7",
    d: "M239.11,201.89a.67.67,0,0,1-.57-1,3.31,3.31,0,0,1,2.05-1.47,3.46,3.46,0,0,1,2.78.88.67.67,0,1,1-.84,1h0a2.18,2.18,0,0,0-1.7-.61,1.92,1.92,0,0,0-1.14.83.66.66,0,0,1-.58.33",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    className: "cls-7",
    d: "M207.59,206c-3.69-10.5,5.29-16.53,5.29-16.53s-2.41-.21-2.7-3.6a8.87,8.87,0,0,0,5.6-.11c12-4.34,20.21-4.28,20.21.84,0,1.82,7.9.58,7.24,12.83.05-.86-2.78-5.9-5.45-6.4s-.26,3.06-5.83,3.83-9.77-.6-13.2,2.57c-2.69,2.77-3.36,16.86-2.95,17.7-.94-1.94-6.59-6.52-8.21-11.13",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    className: "cls-7",
    d: "M246.16,207.84s.5,6.39-.42,8.36c-1-2.56-3,.15-5,.41-4.67.62-13.1-.94-13.93,6.07-5.71,1.81-11.06-10.42-11.06-10.42-.33,13.66,9.66,21.41,24,19.14,9.47-1.5,10.35-14.69,6.31-23.56",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    className: "cls-6",
    d: "M236.31,220.93a12,12,0,0,1-2.89-1.13.54.54,0,0,1-.15-.74.54.54,0,0,1,.66-.2c2.21,1.18,4.19,1.52,5.89,1a5.61,5.61,0,0,0,3.07-2.43.53.53,0,0,1,.94.49,6.53,6.53,0,0,1-3.68,3,7.15,7.15,0,0,1-3.84.06",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    className: "cls-5",
    d: "M215.66,212.35c2.41,1.35,3.46,4.05,2.36,6s-4,2.47-6.36,1.12-3.46-4-2.35-6,3.95-2.47,6.35-1.12",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    className: "cls-6",
    d: "M215.3,218.25a.6.6,0,0,0,.18-.21,2.73,2.73,0,0,0-.29-3.34,2.9,2.9,0,0,0-3.31-.6.6.6,0,0,0-.26.81.61.61,0,0,0,.81.26,1.72,1.72,0,0,1,1.9.37,1.56,1.56,0,0,1,.09,1.93.59.59,0,0,0,.24.81.61.61,0,0,0,.64,0",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M241.18,444.8c1.51-4.1,4.73-4.55,4.73-4.55,6.26,8.64,21.63,3.34,21.12,15-23.37-.15-33.09,0-33.09,0a85.63,85.63,0,0,1,1-11.55l1.22.23Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    d: "M206.2,445c1.51-4.09,4.73-4.54,4.73-4.54,6.26,8.63,21.63,3.33,21.13,15-23.38-.15-33.1,0-33.1,0A85.34,85.34,0,0,1,200,444l1.22.22Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    className: "cls-7",
    d: "M256.73,308.39s3.8,55.35,2.25,67.66-7,28.09-6.38,68.8c-7.62,1.9-18.66,0-18.66,0s-1.64-46,6.42-66.59c-3.27-20-13.79-65.72-13.79-65.72Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    className: "cls-8",
    d: "M242.31,309.9s-7.67,62.15-11.42,73.94S219.82,405.59,213,445.7c-7.83.39-15.13,0-15.13,0s1.06-50.87,13.26-62.44c.41-20.25-2-73-2-73Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    className: "cls-9",
    d: "M207,239.37s13.32-4.66,17.75-2.53c13.8,6.64,17,0,17,0,4.41.38,17.71,2.53,17.71,2.53,0,14.85,1,29.76.72,41-.19,9.79,1.68,36.44,1.68,36.44s-14.68,3.84-28.56,3.94a130.67,130.67,0,0,1-28-3.79s.74-27,1.36-37c-.2-11.24.39-25.76.39-40.58",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    className: "cls-10",
    d: "M283.05,261.45c-5.49-13.11-21.79-21.45-23.66-22.08l-3.78,16.82a98.82,98.82,0,0,1,13.52,9.65c-1,4.68-.81,9.28-3.52,15.2,0,0,2.36-3.25,5.26-1.32s8-2,8-2,8.36-6.31,4.16-16.32",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    className: "cls-11",
    d: "M280,294.58a1.5,1.5,0,0,0,.29.06h.31a1.51,1.51,0,0,0,1.27-1l14.64-47.22a1.32,1.32,0,0,0,.06-.48.4.4,0,0,0,0-.11.36.36,0,0,0,0-.1,1.49,1.49,0,0,0-1-1.18l-.27-.06h-37.2l-14.77,50.19H280Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    className: "cls-12",
    d: "M258.39,244.51a1.48,1.48,0,0,0-1.86,1h0L242,292.6l0,.11a1.48,1.48,0,0,0,1,1.85h0a1.49,1.49,0,0,0,1.86-1h0l14.59-47.22a1.5,1.5,0,0,0-1-1.86h0",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    className: "cls-5",
    d: "M286.25,274.47a1.58,1.58,0,0,1,.44-.19l-.05-.07c-.92-1.38-.85-3,.14-3.69a1.67,1.67,0,0,1,.53-.23,2.22,2.22,0,0,1,.68-2.47,1.66,1.66,0,0,1,.95-.26,2.21,2.21,0,0,1,.73-2.59,2.6,2.6,0,0,1,2.83,4.28,1.8,1.8,0,0,1-.82.29c.66,1.29.53,2.7-.37,3.29a1.48,1.48,0,0,1-.53.23,2.22,2.22,0,0,1-.68,2.47,1.72,1.72,0,0,1-.88.27,1.91,1.91,0,0,1-.58,2.29,2.2,2.2,0,0,1-2.39-3.62",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    className: "cls-5",
    d: "M240.92,271.49l3.36-1.95a6.34,6.34,0,0,1,6.33-4.88l-1.51,4.88s2.65,2.06,9-1.47c6.16-1.38,3.52,3.11,5.57,3.43,3,.48-2.2,6.4-8.35,7.3-8,1.17-8.9-.46-8.9-.46l-4.51,1.58Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    "data-name": "Path 2235",
    className: "cls-13",
    d: "M209.81,276.58c11.24-.78,30.4-6.33,30.4-6.33,3.07,4.7,2.22,10.95,2.22,10.95-17.45,15.3-43.7,20.24-51.76,16.56-7.36-3.36-2.16-48.14,16.3-58.39,6.34,10.71,2.84,37.21,2.84,37.21",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    "data-name": "Path 2236",
    d: "M390.88,440.64c-6.26,8.35-21.63,3.23-21.12,14.52,23.37-.14,33.09,0,33.09,0a79.94,79.94,0,0,0-1-11.16Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    "data-name": "Path 2237",
    d: "M425.86,440.86c-6.26,8.35-21.63,3.23-21.12,14.52,23.37-.14,33.09,0,33.09,0a79.94,79.94,0,0,0-1-11.16Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    "data-name": "Path 2238",
    className: "cls-7",
    d: "M380.06,313.17s-3.8,53.51-2.25,65.41,7,27.15,6.38,66.51c7.62,1.84,18.66,0,18.66,0s1.64-44.5-6.42-64.38c3.27-19.3,13.79-63.53,13.79-63.53Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    className: "cls-8",
    d: "M394.48,314.63s7.67,60.08,11.42,71.48,11.07,21,17.86,59.8a81.34,81.34,0,0,0,17.17-1.55s-3.1-47.63-15.3-58.81c-.41-19.58,2-70.54,2-70.54Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    className: "cls-5",
    d: "M425.7,216.33c-4.16,10.38-14.13,16.15-22.29,12.89s-11.39-14.32-7.24-24.7,14.14-16.15,22.29-12.89,11.39,14.32,7.24,24.7",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M399.72,207.92a1.53,1.53,0,0,1-2.51-1.74,1.53,1.53,0,0,1,2.51,1.74",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M411.16,212.59a1.66,1.66,0,1,1-.42-2.3,1.65,1.65,0,0,1,.42,2.3",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    className: "cls-6",
    d: "M402,210.36C400,212,397.39,214,397.39,214a4,4,0,0,0,2.88,3.57c-1-1-2-2.22-.88-3.69s2.65-3.47,2.65-3.47",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M414.17,211.6a.76.76,0,0,1-.74-.59c0-.08-.54-2.06-2.24-2.07a.77.77,0,0,1,0-1.53c2.33,0,3.44,2.13,3.71,3.25a.77.77,0,0,1-.57.92l-.17,0",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M401.32,204.69a.62.62,0,0,1-.55-.31,1.84,1.84,0,0,0-1.1-.79,2,2,0,0,0-1.61.58.65.65,0,0,1-.9-.1.64.64,0,0,1,.1-.89,3.26,3.26,0,0,1,2.65-.84,3.15,3.15,0,0,1,2,1.4.65.65,0,0,1-.23.87.72.72,0,0,1-.32.08",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M422.8,217.42c-3-9.66.8-14.79.8-14.79-2.58-.52-3.59.37-3.59.37a5.74,5.74,0,0,1-.31-5c-5.33-2.08-8,1.38-12.8,2.54-6.59,1.59-14.72-1-15.48-9.08a1.37,1.37,0,0,1,1.23-1.5,1.41,1.41,0,0,1,.91.24,6.08,6.08,0,0,0,3.58,1,6.51,6.51,0,0,1-1.45-3.71,1.37,1.37,0,0,1,2.27-1.07c1.37,1.14,3.91,2.21,8.44,1.36,3-.56,9.92-5.39,14.22-4.45,3.51.78,6.3,3.76,7.5,8.05a11,11,0,0,1,9.5,10.4c.85,9.34-10,16.5-10,16.5Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    className: "cls-5",
    d: "M421.62,215.8c-2.29,1.3-3.28,3.87-2.22,5.74s3.78,2.34,6.07,1,3.28-3.86,2.22-5.73-3.78-2.34-6.07-1",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    className: "cls-6",
    d: "M422,221.42a.81.81,0,0,1-.18-.19,2.61,2.61,0,0,1,.27-3.19,2.78,2.78,0,0,1,3.15-.59.57.57,0,0,1-.51,1,1.65,1.65,0,0,0-1.81.36,1.48,1.48,0,0,0-.09,1.84.57.57,0,0,1-.83.74",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    "data-name": "Path 2249",
    className: "cls-4",
    d: "M397.86,220.84a.49.49,0,0,1,.16-.67.46.46,0,0,1,.36-.06,34.56,34.56,0,0,0,9.13.81.49.49,0,0,1,.5.47.47.47,0,0,1-.13.34,6.07,6.07,0,0,1-8.54.87,5.81,5.81,0,0,1-1.47-1.76",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    className: "cls-7",
    d: "M386.89,234.44s.39-1.06-33.25-.79l-9,10.66c9.34,7.49,40.6,8.82,40.6,8.82Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    "data-name": "Path 2251",
    className: "cls-11",
    d: "M399.12,233.57l10.61-1L420,235.45l-11.57,11.9Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    "data-name": "Path 2252",
    className: "cls-5",
    d: "M402.8,239c4.32,3.55,5.2,6,14.39,1.25l1.38-14.12-15-1.18Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    "data-name": "Path 2253",
    className: "cls-11",
    d: "M422.72,241.13h0l-3.15-1.24.42-4.44-8.72,7-2.46.39-2.36-.82-7.33-8.44-.38,4.44-2.77.56-10,1.62-1.19,55.53-3.95,18.9a95.37,95.37,0,0,0,42.73,3.51l-.5-19,10.37-54.28Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    "data-name": "Path 2254",
    className: "cls-8",
    d: "M406.89,248.45l-6.27,42.41,3.47,4.82,4.53-3.48,1.54-43.4Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2255",
    "data-name": "Path 2255",
    className: "cls-8",
    d: "M406.52,243.45l2.29-.61,2.33,1-1,5-3.28-.3Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2256",
    "data-name": "Path 2256",
    className: "cls-8",
    d: "M399,233.93l-1.57,51.22-6.78,33s-10.72-1.08-17.31-7.34L381.76,286l2.88-51.88Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    "data-name": "Path 2257",
    className: "cls-14",
    d: "M399,233.93l-1.56,50.53-7.81-38.73Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    "data-name": "Path 2258",
    className: "cls-8",
    d: "M420.8,237.21l-13.93,83s18.48,2.27,26.08-2.73l-4.13-27.3,5-46.34Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    className: "cls-14",
    d: "M420.8,237.21l-8.14,48.67,14.57-36.72Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2260",
    "data-name": "Path 2260",
    className: "cls-5",
    d: "M328.79,188.37c.75,2.59,1,5.38,4.25,6.78,0,0-.48,8.6-.12,15.65l7.95-9a48,48,0,0,1-.39-11.27c.12-.8.27-1.59.4-2.38.34-1.93.91-3.9-.27-6.23-4.54-9-3-11.95-3.63-12.39-1-.45-3.41,1.36-2.06,5.78s1,6.37,1,6.37-3.43-.64-4.65.56c-.55.54-3.33,3.07-2.47,6.1",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2261",
    "data-name": "Path 2261",
    className: "cls-7",
    d: "M330.64,200.49c4.64-1.55,7.08-2.24,10.68-2.24,8.52,25.39,14.59,35,12.06,42.25-2.11,6.08-8.79,5.59-12.06,1-4.31-6-8.13-28.83-10.68-41",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2262",
    "data-name": "Path 2262",
    className: "cls-7",
    d: "M433.86,243.88l26.85,42,31.88,18-9.82,9.79-32-14-22-31Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2263",
    "data-name": "Path 2263",
    className: "cls-4",
    d: "M408.81,242.84s-3.95,4-7.58,5l-4.3-11.36,2.19-2.92Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2264",
    "data-name": "Path 2264",
    className: "cls-4",
    d: "M408.81,242.84a18.9,18.9,0,0,0,6.57,6.28l6.24-10.38-1.63-3.3Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2265",
    "data-name": "Path 2265",
    className: "cls-11",
    d: "M438,362.41H203.62c-5.5,0-10-3-10-6.71s4.47-6.72,10-6.72H438c5.51,0,10,3,10,6.72s-4.46,6.71-10,6.71",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2266",
    "data-name": "Path 2266",
    className: "cls-11",
    d: "M291.48,457h0a3.17,3.17,0,0,1-3.17-3.17,3.1,3.1,0,0,1,.52-1.72l61.89-94.85,5.3,3.46-61.89,94.84a3.16,3.16,0,0,1-2.65,1.44",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2267",
    "data-name": "Path 2267",
    className: "cls-11",
    d: "M350.18,457h0a3.17,3.17,0,0,0,3.16-3.17,3.1,3.1,0,0,0-.52-1.72l-61.89-94.85-5.29,3.46,61.89,94.84a3.15,3.15,0,0,0,2.65,1.44",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2268",
    "data-name": "Path 2268",
    className: "cls-12",
    d: "M447.36,455.5h0a3,3,0,0,1-3-3V398.78h6.06v53.68a3,3,0,0,1-3,3",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2269",
    "data-name": "Path 2269",
    className: "cls-12",
    d: "M468.62,455.5h0a3,3,0,0,1-3-3V398.78h6.06v53.68a3,3,0,0,1-3,3",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2270",
    "data-name": "Path 2270",
    className: "cls-12",
    d: "M496.52,455.5h0a3,3,0,0,1-3-3V398.78h6.06v53.68a3,3,0,0,1-3,3",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2271",
    "data-name": "Path 2271",
    className: "cls-12",
    d: "M517.78,455.5h0a3,3,0,0,1-3-3h0V398.78h6.06v53.68a3,3,0,0,1-3,3h0",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2272",
    "data-name": "Path 2272",
    className: "cls-11",
    d: "M484.26,319.1V383a1.32,1.32,0,0,1-1.32,1.32H443.33a7.24,7.24,0,0,0,0,14.47h48.16a7.24,7.24,0,0,0,7.24-7.24h0V319.1a7.24,7.24,0,1,0-14.47-.13v.13",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_898",
    "data-name": "Rectangle 898",
    className: "cls-11",
    x: 491.49,
    y: 311.88,
    width: 31.32,
    height: 73.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2273",
    "data-name": "Path 2273",
    className: "cls-12",
    d: "M515.57,319.1V383a1.32,1.32,0,0,1-1.31,1.32H474.65a7.24,7.24,0,0,0,0,14.47h48.16a7.23,7.23,0,0,0,7.23-7.24V319.1a7.23,7.23,0,0,0-7.23-7.23h0a7.24,7.24,0,0,0-7.24,7.23h0",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2274",
    "data-name": "Path 2274",
    className: "cls-12",
    d: "M191.33,455.5h0a3,3,0,0,0,3-3V398.78H188.3v53.68a3,3,0,0,0,3,3",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2275",
    "data-name": "Path 2275",
    className: "cls-12",
    d: "M170.07,455.5h0a3,3,0,0,0,3-3V398.78H167v53.68a3,3,0,0,0,3,3",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2276",
    "data-name": "Path 2276",
    className: "cls-12",
    d: "M142.17,455.5h0a3,3,0,0,0,3-3V398.78h-6.06v53.68a3,3,0,0,0,3,3",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2277",
    "data-name": "Path 2277",
    className: "cls-12",
    d: "M120.9,455.5h0a3,3,0,0,0,3-3V398.78h-6.07v53.68a3,3,0,0,0,3,3",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2278",
    "data-name": "Path 2278",
    className: "cls-11",
    d: "M154.43,319.1V383a1.32,1.32,0,0,0,1.32,1.32h39.61a7.24,7.24,0,0,1,0,14.47H147.2a7.24,7.24,0,0,1-7.24-7.24h0V319.1a7.24,7.24,0,0,1,7.24-7.23h0a7.23,7.23,0,0,1,7.23,7.23h0",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_899",
    "data-name": "Rectangle 899",
    className: "cls-11",
    x: 115.88,
    y: 311.88,
    width: 31.32,
    height: 73.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    "data-name": "Path 2279",
    className: "cls-12",
    d: "M123.11,319.1V383a1.32,1.32,0,0,0,1.32,1.32H164a7.24,7.24,0,0,1,0,14.47H115.88a7.24,7.24,0,0,1-7.24-7.24h0V319.1a7.24,7.24,0,0,1,14.47,0",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    className: "cls-8",
    d: "M468.14,294.69c-6.69-2.41-17-7.68-10.15-17.32s6.69-5.42,4.22-17.12,5.85-20.91,13.78-18.58,9.95,8.75,19.68,7.12,17.8,7.47,14.14,15.36-5.22,11.68-1.8,16,18.84,9.07,12.41,19.53-9.38,9.81-7.15,15.17-2.91,11.46-11.85,10.63-17-4.22-20.31-14.2-13-16.63-13-16.63",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    className: "cls-5",
    d: "M444.49,446.67l-5.28,1.58-4-4.06c.19-.29,0-3-.61-5.91l9.86-1.64c.4,3,0,7,0,10",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    className: "cls-9",
    d: "M439.25,447.3a5.41,5.41,0,0,0-3.94-3.66c-5.21,7-18,2.69-17.6,12.1,19.48-.12,27.58,0,27.58,0a67.27,67.27,0,0,0-.86-9.3l-1,.18Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    className: "cls-5",
    d: "M409.37,447.66l-5.5.37-3.16-3.37c.25-.23.85-4.4.89-7.36l9.26.41a85.91,85.91,0,0,1-1.49,10",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2284",
    "data-name": "Path 2284",
    className: "cls-9",
    d: "M404.47,447.3a5.42,5.42,0,0,0-3.94-3.66c-5.22,7-18,2.69-17.61,12.1,19.49-.12,27.58,0,27.58,0a64.32,64.32,0,0,0-.86-9.3l-1,.18Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    className: "cls-15",
    d: "M465,355.71c-15,2-57.3,17.69-59.66,20.53-4.86,5.85-2.3,37.72-4.61,64L413,441c5.89-21.42,5.42-30.66,8.08-55.22,0,0,48.31,3.62,65.77-8.16,18-12.15-9.73-24.77-21.87-21.89",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2286",
    "data-name": "Path 2286",
    className: "cls-6",
    d: "M445.42,324.5c3.54.6,4.91,3.45,5.76,8.69-13.51,8-33.59,8.53-33.59,8.53l-6.4-3.17s16.1-5.79,34.23-14.05",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2287",
    "data-name": "Path 2287",
    className: "cls-6",
    d: "M482.37,309.51c-5.92,8.6-28.57,27.08-32.32,27.66l-4.55-12.71s22.12-23.95,26.15-28.18c7-7.34,20.4-.78,10.72,13.23",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2288",
    "data-name": "Path 2288",
    className: "cls-16",
    d: "M457.45,308.14c4.75-5.11,10.92-16.65,19-15.83s8.62,9.35,6.2,13.95-10.79,15.91-10.79,15.91Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2289",
    "data-name": "Path 2289",
    className: "cls-5",
    d: "M458.91,329.76c3.41,1.17,5.35,11.91,4.4,12.72-14.61,5.79-45-.47-45-.47l-1.61-5.5s23-1.41,42.21-6.75",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2290",
    "data-name": "Path 2290",
    className: "cls-9",
    d: "M507,364.73c-3.34-17.23-4.78-23.34-6.17-31.45-3.43-20,6.65-34.13-10.63-43.73l-12.6,2c-10.18,10.72-16.46,20.44-17,27.16-.74,8.67,7.86,13.37,7.86,13.37L465,355.71s-.82,1.93,13.39,4.61,28.6,4.41,28.6,4.41",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2291",
    "data-name": "Path 2291",
    className: "cls-5",
    d: "M496.61,312c-5.91,8.69-31.18,30.79-35,31l-2.72-13.18s23-26.91,27-31.19c7-7.42,20.4-.79,10.71,13.39",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2292",
    "data-name": "Path 2292",
    className: "cls-16",
    d: "M472.45,312c4.41-6.42,13.32-18.27,21.36-17.45s8.62,9.35,6.19,13.95-10.79,15.91-10.79,15.91Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    className: "cls-5",
    d: "M416.7,336.51c-4.65-1.14-14.75-4.53-18.82,6.11,1,1.95,4.76-2.87,6.37-3.32,2.55-.71,4.73.63,6.66,2.48,2.77,2.64,7.4.23,7.4.23Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    className: "cls-16",
    d: "M413.08,348.87H369.44V343h49.5a5.86,5.86,0,0,1-5.86,5.86",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2295",
    "data-name": "Path 2295",
    className: "cls-16",
    d: "M347,312.06l22.44,36.81,5.19-2.72-25.17-42a5.87,5.87,0,0,0-2.46,7.92",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    className: "cls-5",
    d: "M495.93,273.13c-2.12,8.86-9.48,14.7-16.44,13s-10.89-10.2-8.77-19.07,9.49-14.7,16.45-13,10.89,10.21,8.76,19.07",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    className: "cls-5",
    d: "M492.56,277.8,481,285s-1,5.11-1.54,6.77c-1.05,3.43,3,4.92,6.42,2.79a10,10,0,0,0,4.3-5Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    className: "cls-8",
    d: "M469.93,263.71c3.29.28,10.41-.29,13-3.37,1.85,6.25,9.72,12.21,16.23,15,.26-6.42.21-18.22-11.29-23.13-9-3.85-18,11.5-18,11.5",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M474,269.42a1.25,1.25,0,1,1-.56-1.67,1.26,1.26,0,0,1,.56,1.67h0",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    d: "M483.76,271.84a1.35,1.35,0,1,1-.6-1.81h0a1.35,1.35,0,0,1,.6,1.81",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    className: "cls-8",
    d: "M485.26,270.72a.47.47,0,0,1-.22-.22,3.61,3.61,0,0,0-2.52-1.75.46.46,0,0,1,.13-.92,4.44,4.44,0,0,1,3.24,2.27.47.47,0,0,1-.23.63.47.47,0,0,1-.4,0",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    className: "cls-8",
    d: "M471.27,267.62l-.12-.09a.48.48,0,0,1,0-.67,3.31,3.31,0,0,1,3.27-.8.47.47,0,0,1-.31.89,2.36,2.36,0,0,0-2.3.58.47.47,0,0,1-.54.09",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    className: "cls-6",
    d: "M474.79,272.13a12.91,12.91,0,0,1-1.93,1.84.5.5,0,0,0-.17.65,6.77,6.77,0,0,0,3,2.11.13.13,0,0,0,.17-.07.13.13,0,0,0,0-.15,6.25,6.25,0,0,1-1.53-1.79.57.57,0,0,1,0-.54c.19-.38.58-1.17.84-1.82a.22.22,0,0,0-.12-.29.23.23,0,0,0-.24.05",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    className: "cls-5",
    d: "M492.58,273.19c-1.69,1.31-2.18,3.5-1.11,4.89s3.32,1.44,5,.12,2.19-3.51,1.11-4.89-3.32-1.44-5-.12",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    className: "cls-6",
    d: "M493.55,277.67a.55.55,0,0,1-.17-.13,2.12,2.12,0,0,1-.16-2.6,2.26,2.26,0,0,1,2.47-.85.47.47,0,1,1-.29.89h0a1.33,1.33,0,0,0-1.42.51,1.19,1.19,0,0,0,.15,1.48.47.47,0,0,1-.09.66.48.48,0,0,1-.49.05",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    className: "cls-17",
    d: "M481.77,358.45c-15,2-57.36,15.75-59.71,18.58-4.87,5.86,6,30.93,9.43,63.22H446c-.15-23,1.69-44.17-5.39-51.67,0,0,40.59-2.7,60.83-2.7,10.31,0,16-34.86-19.65-27.43",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    className: "cls-4",
    d: "M474.15,279.59a.39.39,0,0,1,.08-.54.38.38,0,0,1,.27-.07,27.47,27.47,0,0,0,7.19,0,.38.38,0,0,1,.43.33.4.4,0,0,1-.08.28,4.76,4.76,0,0,1-6.61,1.26,4.83,4.83,0,0,1-1.28-1.27",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    className: "cls-5",
    d: "M185.91,333.66c-2.87,1.91-2.07,12.3-1,12.83C199.82,348.31,225,336,225,336l1-5.52s-21,3.52-40.08,3.22",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    className: "cls-5",
    d: "M153.16,315.64c5.33,8.52,28.65,30.55,32.27,30.88L188.51,334s-20.93-26.54-24.62-30.78c-6.37-7.35-19.45-1.51-10.73,12.39",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    className: "cls-8",
    d: "M165.91,270.11c.64-8.72-1.88-16.43-8.84-20.36s-15.88-.07-15.88-.07-7.48-2.66-14.25,4.8-1.65,14-4.43,19.47c-1.64,3.23-10,3.89-7.83,14.39.62,3,4.26,5.07,7.35,5.27,5.42.36,10.46-1.74,12.66.36,7.24,6.9,23.29,4.4,25.53-1.91.7-2,15.13,1.83,13.69-11.51-.73-6.75-8.57-2.64-8-10.44",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    className: "cls-5",
    d: "M152.68,298.31l-11.45-2.11-4.3,5.71,9.13,18.72,13.43-11.39Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    className: "cls-17",
    d: "M167.53,343.45c-.19-3.56,5.57-18.19,2.54-25.55-2.21-5.93-5.9-15.87-10.41-17.53-2.13-.78-4.32-1.33-7-2.06,0,0,1.5,7.46-1.62,7.71-6,.49-9.83-9.82-9.83-9.82-3.24-.31-18.1,4.57-18.09,5.79,0,9.55,7.8,23.49,10.34,33.82,1,11.15-2.9,24.5-2.91,25.77,0,0,23.89,6.72,38.06-1.08.3-1.08-.82-12.13-1.1-17.05",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2313",
    "data-name": "Path 2313",
    className: "cls-17",
    d: "M134.16,350.12s-5.27,13.31-6.56,21.69,6,13.75,6,13.75H194s6.46-10.48,4.6-17.72-6.14-8.39-6.14-8.39Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2314",
    "data-name": "Path 2314",
    className: "cls-6",
    d: "M194.76,359.08c-7.71-1.09-30.08,7.6-39.62,26.48h26.69Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2315",
    "data-name": "Path 2315",
    className: "cls-6",
    d: "M186.3,366a20.92,20.92,0,0,0,2.7-3.84,6.66,6.66,0,0,1,10.73-1.26c11.13,12.27,34.85,40.24,40.14,43.72,1.49,1,10.21,6,18.5,5,0,0,4.09,1.56,1.37,4.8-1.41,1.68-22.47,3.4-22.47,3.4l-1.64-6.18c-12.26-9.07-27.52-8.42-40.46-25C188,377.53,186.31,366,186.31,366",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2316",
    "data-name": "Path 2316",
    className: "cls-9",
    d: "M241.54,421.43l8.47,5.5,1.17-1.39-6.88-6.41c3.91-3.08,12.95-.51,12.95-.51,3-1.91,8.74-8.12,9.34-11.44-1.9-2.37-8.22,2.49-8.22,2.49.23,1.06-1.76,4.7-3.35,5.33-6.9,1.49-13.78-.47-19.39-3.32,0,0-4.69,7.1,5.91,9.75",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2317",
    "data-name": "Path 2317",
    className: "cls-5",
    d: "M186.18,367.69a4,4,0,0,0-2.92,3.29c-.6,4.29-3.72,13,.5,22,10.35,22.29,16.47,37,17.55,42.73-2.7,5.07,8.08,18.9,8.24,19.81l7.76-2.43s-4.45-6.63-6.05-9.22c-3.82-6.18-4.45-13.76-5.07-19.63-2.65-25.09,1.91-40.93-16.24-55.64a4.25,4.25,0,0,0-3.77-.95",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2318",
    "data-name": "Path 2318",
    className: "cls-9",
    d: "M197.45,446.36l.76,10.08,1.81.08.93-9.35c4.82,1.24,8.26,10,8.26,10,3.32,1.19,11.75,2,14.76.48.73-2.94-7-5-7-5-.7.82-4.81,1.45-6.27.57-5.36-4.59-8.28-11.25-9.42-17.44,0,0-8.19.58-3.86,10.61",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2319",
    "data-name": "Path 2319",
    className: "cls-5",
    d: "M149.79,289l-9.31-1.39.74,8.63s1.78,3.92,3.85,4.18l7.61-2.06Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2320",
    "data-name": "Path 2320",
    className: "cls-5",
    d: "M131.88,276.47c2.4,10,10.73,16.63,18.61,14.74s12.31-11.54,9.91-21.57S149.67,253,141.79,254.89s-12.31,11.55-9.91,21.58",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2321",
    "data-name": "Path 2321",
    d: "M156.71,272.27a1.41,1.41,0,1,0,.64-1.89,1.41,1.41,0,0,0-.64,1.89",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2322",
    "data-name": "Path 2322",
    d: "M145.65,275a1.53,1.53,0,1,0,.68-2h0a1.52,1.52,0,0,0-.68,2",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    "data-name": "Path 2323",
    className: "cls-8",
    d: "M144,273.74a.55.55,0,0,0,.25-.25,4.07,4.07,0,0,1,2.85-2,.52.52,0,0,0,.44-.6.53.53,0,0,0-.59-.45,5.06,5.06,0,0,0-3.66,2.58.52.52,0,0,0,.26.7.51.51,0,0,0,.45,0",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2324",
    "data-name": "Path 2324",
    className: "cls-8",
    d: "M159.79,270.23a.53.53,0,0,0,.23-.71.45.45,0,0,0-.1-.14,3.7,3.7,0,0,0-3.69-.91.52.52,0,0,0-.33.67.52.52,0,0,0,.67.33,2.7,2.7,0,0,1,2.61.66.53.53,0,0,0,.61.1",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2325",
    "data-name": "Path 2325",
    className: "cls-6",
    d: "M155.81,275.33a14,14,0,0,0,2.19,2.09.56.56,0,0,1,.18.74c-.59,1.06-2.34,1.93-3.4,2.38a.15.15,0,0,1-.2-.08.14.14,0,0,1,0-.17,7.12,7.12,0,0,0,1.73-2,.66.66,0,0,0,0-.61c-.22-.43-.66-1.32-.95-2.06a.25.25,0,0,1,.13-.33.26.26,0,0,1,.28.06",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2326",
    "data-name": "Path 2326",
    className: "cls-5",
    d: "M135.67,276.53c1.91,1.49,2.48,4,1.26,5.53s-3.76,1.63-5.68.14-2.47-4-1.26-5.53,3.76-1.63,5.68-.14",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2327",
    "data-name": "Path 2327",
    className: "cls-6",
    d: "M134.58,281.61a.46.46,0,0,0,.18-.16,2.39,2.39,0,0,0,.19-2.94,2.56,2.56,0,0,0-2.8-1,.53.53,0,0,0-.34.67.54.54,0,0,0,.67.34h0a1.52,1.52,0,0,1,1.61.57,1.37,1.37,0,0,1-.17,1.69.53.53,0,0,0,.1.74.54.54,0,0,0,.56.05",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2328",
    "data-name": "Path 2328",
    className: "cls-4",
    d: "M147.1,283.33a.43.43,0,0,1,.08-.59.39.39,0,0,1,.31-.08,30.3,30.3,0,0,0,8,0,.43.43,0,0,1,.47.37.46.46,0,0,1-.08.3,5.28,5.28,0,0,1-7.33,1.42,5.15,5.15,0,0,1-1.41-1.42",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2329",
    "data-name": "Path 2329",
    className: "cls-8",
    d: "M131.68,275.58c9.4-1.26,22.56-10.84,23.64-15.76-1.82-5.9-11.51-8.87-17-6.13s-10.64,14.46-6.66,21.89",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    "data-name": "Path 2330",
    className: "cls-4",
    d: "M219.65,346.69h0a2.39,2.39,0,0,1-1.53-3l14.52-44.46a2.38,2.38,0,0,1,3-1.53h0a2.39,2.39,0,0,1,1.53,3l-14.52,44.46a2.38,2.38,0,0,1-3,1.53",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2331",
    "data-name": "Path 2331",
    className: "cls-5",
    d: "M227.36,330.75l3-9.06s2.56,5.21,0,10.16-5,5.17-5,5.17Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2332",
    "data-name": "Path 2332",
    className: "cls-5",
    d: "M223.13,328.33c-.74-1.76-2.51-6.16-.74-6.14s2,2.16,2,2.16Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2333",
    "data-name": "Path 2333",
    className: "cls-5",
    d: "M77.74,301.85a6.6,6.6,0,0,0,1.37-8.16c2.19-.47,13.74,17,18.73,28.16,8.69-8.76,24-20.59,28.14-21.28,0,0,5.59-1.5,7.6,5.26,1.79,6-5.2,10.3-5.2,10.3s-29.89,21.1-34.31,19.23c-6.88-2.92-13.11-28-16.33-33.51",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2334",
    "data-name": "Path 2334",
    className: "cls-5",
    d: "M71.5,301.35c2.43.15,5.45-1.05,6.39,1.13l4.82-2.34.29-2.91c-4.14-6.63-14.22-8.51-15.22-8.59-2.59-.23-3.8-.5-4-.15s-.84,2.65,2.93,3.11c4.72.56,1.58,4.34-8,.74-2.4-.9-6.91.27-5.28,2,1.8,1.93,7,6.31,18.07,7",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    className: "cls-17",
    d: "M332.3,166.38a19.24,19.24,0,0,1-1.08,6.34c-3.54,10.15-15.33,17.6-29.35,17.6s-25.81-7.45-29.34-17.6a19,19,0,0,1-1.09-6.34Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    "data-name": "Path 2336",
    className: "cls-15",
    d: "M332.3,166.38a19.24,19.24,0,0,1-1.08,6.34H272.53a19,19,0,0,1-1.09-6.34Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    "data-name": "Path 2337",
    className: "cls-18",
    d: "M365.6,63.72a63.73,63.73,0,1,0-114.09,39,79.73,79.73,0,0,1,16.9,48.89V152h66.92v-.31a80,80,0,0,1,16.95-49,63.44,63.44,0,0,0,13.32-39",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    "data-name": "Path 2338",
    className: "cls-4",
    d: "M311.51,144.76a1.63,1.63,0,0,1-1.63-1.63,1.61,1.61,0,0,1,.09-.54c.08-.21,7.59-21.86,13-43.91,9.68-39.08,4.7-45.43,2.11-46.34-7.62-2.7-13.68,1.29-17.43,5.11a33.47,33.47,0,0,0-3.15,3.77,61.77,61.77,0,0,1,4.32,9.21c3.38,9,4.28,17.43,2.4,22.52a8,8,0,0,1-8.64,5.61c-3.9-.3-6.75-2.55-8.25-6.53-1.71-4.56-1.49-11.26.61-18.39a49.33,49.33,0,0,1,5.72-12.56A31.52,31.52,0,0,0,293,52.4c-4.19-3-8.13-3.19-11.7-.39-7.38,5.77-7.66,23.12-.82,50.17a358.77,358.77,0,0,0,13.1,40.34,1.63,1.63,0,0,1-3,1.22A361,361,0,0,1,277.37,103c-7.3-28.82-6.64-46.85,2-53.57,4.72-3.69,10.28-3.57,15.63.33a33.83,33.83,0,0,1,7.75,8.48,34.07,34.07,0,0,1,2.67-3.08c6.23-6.36,13.63-8.46,20.84-5.91,4.48,1.59,6.33,7.63,5.63,18.46-.52,8-2.43,18.68-5.67,31.76-5.5,22.19-13.05,44-13.13,44.18a1.63,1.63,0,0,1-1.54,1.1m-8.94-80.49a46.48,46.48,0,0,0-4.45,10.29c-1.88,6.37-2.13,12.47-.68,16.33,1,2.78,2.82,4.22,5.44,4.42a4.74,4.74,0,0,0,5.34-3.48c2.16-5.87-.46-17.86-5.65-27.56",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2339",
    "data-name": "Path 2339",
    className: "cls-17",
    d: "M329.68,168.46H274.06a12,12,0,0,1-12-12V156a12,12,0,0,1,12-12h55.63a12,12,0,0,1,12,12v.51a12,12,0,0,1-12,12h0",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    "data-name": "Path 2340",
    className: "cls-18",
    d: "M410.13,66.34H389.29a5.37,5.37,0,0,1,0-10.74h20.84a5.37,5.37,0,0,1,0,10.74",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2341",
    "data-name": "Path 2341",
    className: "cls-18",
    d: "M214.45,66.34H193.61a5.37,5.37,0,0,1-.11-10.74h20.95a5.37,5.37,0,0,1,0,10.74",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2342",
    "data-name": "Path 2342",
    className: "cls-18",
    d: "M227.69,22.26,211.11,9.64a5.37,5.37,0,1,1,6.46-8.57l0,0,16.58,12.61a5.37,5.37,0,0,1-6.5,8.55",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2343",
    "data-name": "Path 2343",
    className: "cls-18",
    d: "M375,22.26,391.57,9.64a5.37,5.37,0,0,0-6.5-8.54L368.49,13.71a5.37,5.37,0,0,0,6.41,8.62l.09-.07",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2344",
    "data-name": "Path 2344",
    className: "cls-18",
    d: "M227.69,106.35,211.11,119a5.37,5.37,0,1,0,6.42,8.62l.09-.07,16.58-12.62a5.37,5.37,0,0,0-6.51-8.54",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    "data-name": "Path 2345",
    className: "cls-18",
    d: "M375,106.35,391.57,119a5.37,5.37,0,0,1-6.5,8.55l-16.58-12.62a5.37,5.37,0,0,1,6.5-8.54",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2346",
    "data-name": "Path 2346",
    className: "cls-17",
    d: "M315.69,326.41A78.76,78.76,0,0,1,309,307.78c-1.66-8.2-1.59-18-1.38-23.21a1.21,1.21,0,0,1,2.23-.58c3,4.93,8.46,14.84,9.69,23.79a184.7,184.7,0,0,1,1.69,18.63Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2347",
    "data-name": "Path 2347",
    className: "cls-17",
    d: "M320.7,326.41A149.3,149.3,0,0,1,327.41,308c2.56-5.36,8.37-11.78,11.35-14.88a.82.82,0,0,1,1.16,0,.84.84,0,0,1,.24.75c-.76,4.08-2.54,12.14-5.43,17.64a83.82,83.82,0,0,1-10.73,15Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    "data-name": "Path 2348",
    className: "cls-15",
    d: "M304.27,316.6a1.11,1.11,0,0,1,.49-1.5,1.1,1.1,0,0,1,.87-.07,19.09,19.09,0,0,1,6.57,3.81,13.62,13.62,0,0,1,4.24,7l-1.23.42s-6.66-1.22-10.94-9.61",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2349",
    "data-name": "Path 2349",
    className: "cls-15",
    d: "M329.28,290.76a1.23,1.23,0,0,0-2.22-.63A46,46,0,0,0,319,308.82c-1.71,10.47.28,17.59.28,17.59h1.41s5.2-9.85,7.23-16.53c1.92-6.3,1.67-14.67,1.35-19.12",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2350",
    "data-name": "Path 2350",
    className: "cls-15",
    d: "M324,326.41s3-10,13.23-13.76a.72.72,0,0,1,.93.44.67.67,0,0,1,0,.52c-1.34,3.3-5.19,11.16-11.69,12.79Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    "data-name": "Path 2351",
    className: "cls-12",
    d: "M333.06,324.72H309.37l3,24.27H330Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2352",
    "data-name": "Path 2352",
    className: "cls-9",
    d: "M307.59,343.7v3.48h1a.83.83,0,0,1,.83.83h0v.14a.84.84,0,0,1-.83.84H268.12a1,1,0,0,1-1-1v-5a1,1,0,0,1,1-1h40.42a.83.83,0,0,1,.83.83.84.84,0,0,1-.83.84Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2353",
    "data-name": "Path 2353",
    className: "cls-4",
    d: "M307.71,347.18H272.36a.71.71,0,0,1-.71-.71h0v-2.06a.71.71,0,0,1,.71-.71h35.35Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    className: "cls-17",
    d: "M263.57,336.18V340h-.95a.89.89,0,0,0-.83.92v.16a.88.88,0,0,0,.83.92H303a1,1,0,0,0,1-1.07v-5.55a1,1,0,0,0-1-1.07H262.62a.92.92,0,0,0-.82,1,.93.93,0,0,0,.82.82Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    className: "cls-4",
    d: "M263.45,340h35.32a.75.75,0,0,0,.75-.74v-2.37a.75.75,0,0,0-.75-.74H263.45Z",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    className: "cls-9",
    d: "M303.42,330.76H266.56a1.47,1.47,0,0,1-1.48-1.47h0V326a1.48,1.48,0,0,1,1.48-1.48h36.86a1.47,1.47,0,0,1,1.47,1.48v3.3a1.47,1.47,0,0,1-1.47,1.47h0",
    transform: "translate(0 0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    className: "cls-12",
    d: "M306.38,334.33H268.8a1.11,1.11,0,0,1-1.11-1.11h0v-1.34a1.11,1.11,0,0,1,1.11-1.12h37.58a1.12,1.12,0,0,1,1.11,1.12h0v1.34a1.12,1.12,0,0,1-1.11,1.12h0",
    transform: "translate(0 0.02)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutus);
export default __webpack_public_path__ + "static/media/aboutus.3b1a7c09251fafc9f0a38512dc057916.svg";
export { ForwardRef as ReactComponent };